import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { ChangePlanStatus } from "~/change-plan.type";
import { ChangePlanService } from "@/services/api/change-plan.service";
import { Plan } from "~/plan";
import { PlansDto } from "~/plans.dto";
import { DataOptions } from "vuetify";
import { PlanDetailsDTO } from "~/plan.details.dto";
import { PlanDetail } from "~/plan.detail";
import { PlanDetailSaveDTO } from "~/plan.detail.save.dto";
import { PlanStatusChangeDTO } from "~/plan.status.change.dto";
import { SaveSignDTO } from "~/save.sign.dto";
import { SavePlanDTO } from "~/save.plan.dto";

@Module({
  dynamic: true,
  store,
  name: "change-plan",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class ChangePlanVuexModule extends VuexModule {
  from = "";
  to = "";
  planStatuseFilter: number = null as any;
  planLoading: boolean = false;
  planListLength: number = 0;
  changePlanStatuses: ChangePlanStatus[] = [];
  planList: Plan[] = [];
  planListPagination: DataOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  };
  planDetailList: PlanDetail[] = [];
  planDetailLoading: boolean = false;
  currentPlan: Plan = null as any;

  @Mutation
  public setCurrentPlan(val: Plan) {
    this.currentPlan = val;
  }

  @Mutation
  public setplanDetailLoading(val: boolean) {
    this.planDetailList = [];
    this.planDetailLoading = val;
  }

  @Mutation
  public setPlanLoading(val: boolean) {
    this.planLoading = val;
  }

  @Mutation
  public setAppealListPagination(val: DataOptions) {
    this.planListPagination = val;
  }

  @Mutation
  public setFrom(val: string) {
    this.from = val;
  }

  @Mutation
  public setTo(val: string) {
    this.to = val;
  }

  @Mutation
  public setPlanStatuseFilter(val: number) {
    this.planStatuseFilter = val;
  }

  @MutationAction
  public async getStatuses() {
    const changePlanStatuses = await ChangePlanService.getStatuses();
    return { changePlanStatuses };
  }

  @MutationAction
  public async getPlans(req: PlansDto) {
    const planList = await ChangePlanService.getChangePlan(req);
    const planListLength = planList.length > 0 ? planList[0].row_count : 0;
    const planLoading = false;
    return { planList, planLoading, planListLength };
  }

  @MutationAction
  public async getRequestChangePlan(req: PlanDetailsDTO) {
    const planDetailList = await ChangePlanService.getRequestChangePlan(req);
    const planDetailLoading = false;
    return { planDetailList, planDetailLoading };
  }

  @Action
  public async savePlan(req: PlanDetailSaveDTO) {
    return await ChangePlanService.savePlan(req);
  }

  @Action
  public async statusChangePlan(req: PlanStatusChangeDTO) {
    return await ChangePlanService.statusChangePlan(req);
  }

  @Action
  public async saveSign(req: SaveSignDTO) {
    return await ChangePlanService.saveSign(req);
  }

  @Action
  public async saveCCPlan(req: SavePlanDTO) {
    return await ChangePlanService.saveCCPlan(req);
  }

  @Action
  public async checkExistsChangePlan(iContractRid: number) {
    return await ChangePlanService.checkExistsChangePlan(iContractRid);
  }

  @Action
  public async getCurrentChangePlanDoc(iContractRid: number) {
    return await ChangePlanService.getCurrentChangePlanDoc(iContractRid);
  }
}

export const ChangePlanModule = getModule(ChangePlanVuexModule);
